<template>
  <div class="fill-height">
    <v-app v-if="!$route.meta.fullPage" id="app">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ siteName }}</v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items>
          <template v-for="(item, index) in routes">
            <v-btn v-if="!item.children" :exact="item.meta.exact" flat :key="index" :to="item"
                   :class="item.meta.hidden ? 'hidden' : ''">
              {{ item.meta.title }}
            </v-btn>
            <v-menu v-else transition="slide-y-transition" bottom offset-y :key="index">
              <v-btn slot="activator" :to="item" :exact="item.meta.exact" flat>{{ item.meta.title }}</v-btn>
              <v-list>
                <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.path">
                  <v-list-tile-title>{{ child.meta.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>

          <v-btn v-if="isAuthenticated" flat @click="logout">Выход</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-container fluid v-if="!$route.meta.noContainer">
          <router-view/>
        </v-container>
        <router-view v-else/>
      </v-content>
      <v-dialog v-model="loadingDialog" persistent content-class="loadingDialog" :transition="false">
        <v-layout align-center justify-center row fill-height>
          <v-flex class="loadingDialog__text text-xs-center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-dialog>
    </v-app>
    <router-view v-else/>
  </div>
</template>

<script>

import SettingsService from '@/services/SettingsService'
import LogonService from '@/services/LogonService'
import RouterUtils from '@/router/RouterUtils'

export default {
  data: () => ({
    siteName: SettingsService.siteTitle,
    logonService: undefined
  }),
  computed: {
    isAuthenticated () {
      return this.logonService.isAuthenticated()
    },
    loadingDialog () {
      return this.$store.getters.isLoading
    },
    routes () {
      return RouterUtils.getMenuByRole(this.$store.getters.getRoles)
    }
  },
  methods: {
    logout () {
      this.logonService.logout()
    }
  },
  components: {},
  created () {
    this.logonService = new LogonService(this.$store)
  }
}
</script>

<style lang="scss">
#app {
  color: #2c3e50;
}

.loadingDialog {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0 !important;
  max-height: 100% !important;
}

.hidden {
  display: none;
}

.v-input__control {
  width: 100% !important;
}
</style>

<style lang="scss" scoped>
.loadingDialog__text {
  $size: 50px;
  height: $size;
  width: $size;
}
</style>



// WEBPACK FOOTER //
// src/App.vue